"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommercialLineItemSharedUpdateFields = exports.CommercialLineItemSharedNestedCreateFields = exports.CommercialLineItemSharedCreateFields = exports.CommercialLineItemSharedQuery = exports.CommercialLineItemSharedFields = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const enums_1 = require("../enums");
const shared_1 = require("./shared");
exports.CommercialLineItemSharedFields = typebox_1.Type.Intersect([
    shared_1.LineItemSharedFields,
    typebox_1.Type.Object({
        onBillID: typebox_1.Type.Optional(typebox_1.Type.String({
            format: 'uuid',
            description: 'References the external ID from the invoice service',
        })),
        billingDetailsID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
        recurrenceType: enums_1.LineItemRecurrenceType,
        recurrenceActive: typebox_1.Type.Boolean(),
    }),
]);
exports.CommercialLineItemSharedQuery = typebox_1.Type.Object({
    customerID: typebox_1.Type.String({ format: 'uuid' }),
    onBillID: typebox_1.Type.String({ format: 'uuid' }),
    billingDetailsID: typebox_1.Type.String({ format: 'uuid' }),
    skuID: typebox_1.Type.String({ format: 'uuid' }),
});
exports.CommercialLineItemSharedCreateFields = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.CommercialLineItemSharedFields, ['id', 'haulerID', 'sku', 'metadata']),
    typebox_1.Type.Object({
        skuID: typebox_1.Type.String({ format: 'uuid' }),
    }),
]);
exports.CommercialLineItemSharedNestedCreateFields = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.CommercialLineItemSharedFields, ['id', 'haulerID', 'sku', 'billingDetailsID', 'metadata']),
    typebox_1.Type.Object({
        skuID: typebox_1.Type.String({ format: 'uuid' }),
    }),
]);
exports.CommercialLineItemSharedUpdateFields = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.CommercialLineItemSharedFields, [
        'id',
        'haulerID',
        'customerID',
        'onBillID',
        'billingDetailsID',
        'unitPrice',
        'percentValue',
    ]),
    typebox_1.Type.Object({
        onBillID: (0, common_1.Nullable)(typebox_1.Type.String({ format: 'uuid' })),
        skuID: typebox_1.Type.String({ format: 'uuid' }),
        unitPrice: (0, common_1.Nullable)(typebox_1.Type.Integer()),
        percentValue: (0, common_1.Nullable)(typebox_1.Type.Number({
            minimum: 0,
            maximum: 10000,
            description: 'in basis points (i.e. percent * 100)',
        })),
    }),
]));
//# sourceMappingURL=commercial-line-item-shared.js.map